import { render, staticRenderFns } from "./BetgameEditChatBot.vue?vue&type=template&id=fe72926e&scoped=true"
import script from "./BetgameEditChatBot.vue?vue&type=script&lang=js"
export * from "./BetgameEditChatBot.vue?vue&type=script&lang=js"
import style0 from "./BetgameEditChatBot.vue?vue&type=style&index=0&id=fe72926e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe72926e",
  null
  
)

export default component.exports